import React from "react";
import { DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDialog } from "../../contexts/DialogContext";

export function CredentialsModal({ titleText, bodyText, children }) {
  const { closeDialog } = useDialog();

  return (
    <>
      <div className="absolute right-0 top-0 pr-4 pt-4">
        <button
          type="button"
          onClick={closeDialog}
          className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          <span className="sr-only">Close</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>

      <div className="mt-3 text-center sm:mt-0 sm:text-left">
        <DialogTitle
          as="h3"
          className="text-lg font-semibold leading-6 text-gray-900"
        >
          {titleText}
        </DialogTitle>
        <div className="mt-2">
          <p className="text-sm text-gray-500">{bodyText}</p>
        </div>
      </div>

      <div className="mt-4 max-h-[50vh] overflow-y-auto">{children}</div>
    </>
  );
}
